"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowIsLandingAction = exports.appMountedAction = exports.SHOULD_SHOW_IS_LANDING = exports.APP_MOUNTED = void 0;
var APP_MOUNTED = 'APP_MOUNTED';
exports.APP_MOUNTED = APP_MOUNTED;
var SHOULD_SHOW_IS_LANDING = 'SHOULD_SHOW_IS_LANDING';
exports.SHOULD_SHOW_IS_LANDING = SHOULD_SHOW_IS_LANDING;

var appMountedAction = function appMountedAction() {
  return {
    type: APP_MOUNTED,
    payload: null
  };
};

exports.appMountedAction = appMountedAction;

var shouldShowIsLandingAction = function shouldShowIsLandingAction(isLanding) {
  return {
    type: SHOULD_SHOW_IS_LANDING,
    payload: isLanding
  };
};

exports.shouldShowIsLandingAction = shouldShowIsLandingAction;